import React from "react";
import {
  Box,
  Flex,
  Heading,
  IconButton,
  useDisclosure,
} from "@chakra-ui/react";
import { HamburgerIcon } from "@chakra-ui/icons";
import NavigationDrawer from "./NavigationDrawer";
import { useNavigate } from "react-router-dom";
import { useTournament } from "../contexts/TournamentContext";

const Layout = ({ children, title }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const navigate = useNavigate();
  const { label, basePath, readOnly } = useTournament();

  const homePath = basePath || "/";

  return (
    <Box bg="green.800" minH="100vh" color="white">
      <Box
        position="fixed"
        top={0}
        left={0}
        right={0}
        bg="green.800"
        p={4}
        borderBottom="1px"
        borderColor="green.700"
        zIndex={1000}
      >
        <Flex justify="space-between" align="center">
          <IconButton
            icon={<HamburgerIcon />}
            onClick={onOpen}
            variant="ghost"
            color="white"
            aria-label="Menu"
          />
          <Heading size="xl" onClick={() => navigate(homePath)} cursor="pointer">
            {title || label}
          </Heading>
          <Box w={8} />
        </Flex>
        {readOnly && (
          <Heading
            size="xs"
            textAlign="center"
            color="green.200"
            fontWeight="normal"
            mt={1}
          >
            Archive — view only
          </Heading>
        )}
      </Box>

      <NavigationDrawer isOpen={isOpen} onClose={onClose} />

      <Box mt={readOnly ? "88px" : "70px"}>{children}</Box>
    </Box>
  );
};

export default Layout;
